import { Component } from '@angular/core';
import { SkeletonComponent } from '@esolutions/design-system-ng/components';

@Component({
  selector: 'app-introexp-placeholder',
  templateUrl: './introexp-placeholder.component.html',
  styleUrls: ['./introexp-placeholder.component.scss'],
  imports: [SkeletonComponent],
  standalone: true
})
export class IntroExpPlaceholderComponent {}
